<form
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="ft-auth__reset m-auto p-4">
  <div class="mb-4">
    <div class="ft-logo"></div>
    <div class="my-4">
      <h1 i18n>Choose a new password</h1>
    </div>
    <div class="d-flex flex-column gap-2">
      <div class="ft-password-field">
        @if (!passwordVisible()) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label i18n>Password</mat-label>
            <input
              type="password"
              matInput
              formControlName="password"
              maxlength="100"
              autocomplete="current-password" />
            @if (!submitting()) {
              <button
                type="button"
                matSuffix
                mat-icon-button
                (click)="togglePasswordVisible()"
                i18n-title
                title="Toggle visibility">
                <ft-icon name="eye" class="ft-icon--2"></ft-icon>
              </button>
            }
            @if (form.get('password')?.invalid) {
              <mat-error>
                @if (form.get('password')?.hasError('required')) {
                  {{ appService.getErrorMessage(form.get('password')) }}
                } @else {
                  <ng-container i18n>It must meet the security requirements</ng-container
                  >
                }
              </mat-error>
            }
          </mat-form-field>
        }
        @if (passwordVisible()) {
          <mat-form-field appearance="fill" class="w-100">
            <mat-label i18n>Password</mat-label>
            <input
              type="text"
              matInput
              formControlName="password"
              maxlength="100"
              autocomplete="off" />
            @if (!submitting()) {
              <button
                type="button"
                matSuffix
                mat-icon-button
                (click)="togglePasswordVisible()">
                <ft-icon
                  name="eye--strike-through"
                  class="ft-icon--2"></ft-icon>
              </button>
            }
            @if (form.get('password')?.invalid) {
              <mat-error>
                @if (form.get('password')?.hasError('required')) {
                  {{ appService.getErrorMessage(form.get('password')) }}
                } @else {
                  <ng-container i18n
                    >It must meet the security requirements</ng-container
                  >
                }
              </mat-error>
            }
          </mat-form-field>
        }
        <div class="ft-password-field__instructions">
          <div
            class="ft-item gap-1"
            [ngClass]="
              form.get('password')?.hasError('minLength')
                ? 'text-muted'
                : 'text-success'
            ">
            <ft-icon
              [name]="
                form.get('password')?.hasError('minLength')
                  ? 'circle'
                  : 'check--circle'
              "
              class="ft-icon--1" />
            <div i18n>Must contain at least 8 characters</div>
          </div>
          <div
            class="ft-item gap-1"
            [ngClass]="
              form.get('password')?.hasError('upperCase')
                ? 'text-muted'
                : 'text-success'
            ">
            <ft-icon
              [name]="
                form.get('password')?.hasError('upperCase')
                  ? 'circle'
                  : 'check--circle'
              "
              class="ft-icon--1" />
            <div i18n>Must contain at least 1 capital letter</div>
          </div>
          <div
            class="ft-item gap-1"
            [ngClass]="
              form.get('password')?.hasError('lowerCase')
                ? 'text-muted'
                : 'text-success'
            ">
            <ft-icon
              [name]="
                form.get('password')?.hasError('lowerCase')
                  ? 'circle'
                  : 'check--circle'
              "
              class="ft-icon--1" />
            <div i18n>Must contain at least 1 lowercase letter</div>
          </div>
          <div
            class="ft-item gap-1"
            [ngClass]="
              form.get('password')?.hasError('specialCharacter')
                ? 'text-muted'
                : 'text-success'
            ">
            <ft-icon
              [name]="
                form.get('password')?.hasError('specialCharacter')
                  ? 'circle'
                  : 'check--circle'
              "
              class="ft-icon--1" />
            <div i18n>Must contain at least 1 special character</div>
          </div>
          <div
            class="ft-item gap-1"
            [ngClass]="
              form.get('password')?.hasError('number')
                ? 'text-muted'
                : 'text-success'
            ">
            <ft-icon
              [name]="
                form.get('password')?.hasError('number')
                  ? 'circle'
                  : 'check--circle'
              "
              class="ft-icon--1" />
            <div i18n>Must contain 1 number</div>
          </div>
        </div>
      </div>
      @if (!confirmPasswordVisible()) {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Confirm password</mat-label>
          <input type="password" matInput formControlName="confirmPassword" />
          @if (!submitting()) {
            <button
              type="button"
              matSuffix
              mat-icon-button
              (click)="toggleConfirmPasswordVisible()"
              i18n-title
              title="Toggle visibility">
              <ft-icon name="eye" class="ft-icon--2"></ft-icon>
            </button>
          }
          @if (form.get('confirmPassword')?.invalid) {
            <mat-error>{{
              appService.getErrorMessage(form.get('confirmPassword'), {
                notEqual: notEqualMessage
              })
            }}</mat-error>
          }
        </mat-form-field>
      } @else {
        <mat-form-field appearance="fill" class="w-100">
          <mat-label i18n>Confirm password</mat-label>
          <input type="text" matInput formControlName="confirmPassword" />
          @if (!submitting()) {
            <button
              type="button"
              matSuffix
              mat-icon-button
              (click)="toggleConfirmPasswordVisible()"
              i18n-title
              title="Toggle visibility">
              <ft-icon name="eye--strike-through" class="ft-icon--2"></ft-icon>
            </button>
          }
          @if (form.get('confirmPassword')?.invalid) {
            <mat-error>{{
              appService.getErrorMessage(form.get('confirmPassword'), {
                notEqual: notEqualMessage
              })
            }}</mat-error>
          }
        </mat-form-field>
      }
      <div class="d-flex justify-content-end">
        <button
          type="submit"
          mat-flat-button
          color="primary"
          style="min-width: 100px"
          [disabled]="!form.valid || submitting()">
          @if (!submitting()) {
            <span i18n>Submit</span>
          } @else {
            <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
          }
        </button>
      </div>
    </div>
  </div>
</form>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
